<div class="main-container centered" @fadeIn>
    <p><strong>Thank you for using Vitralogy Binder</strong></p>
    <p class="secondary">Invalid code, please contact customer support at Vitralogy for more info</p>
</div>
